<template>
  <v-content>
    <v-container @keyup.enter='updatePassword' class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12" v-if="token != null && loadingdata == false && routerenter == false && isAuthenticated== false">
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>{{ 'Update Password' | translate }}</v-toolbar-title>
              </v-container>
              <v-spacer />
              <v-toolbar-items>
                <v-select
                  @change="changedLanguage"
                  :value="selectedLanguage"
                  :items="languages"
                  item-value="lang_code"
                  item-text="lang_name"
                  :label="'Language' | translate "
                  outlined
                  dense
                  class="pt-3"
                  style="width:140px;"
                ></v-select>
              </v-toolbar-items>
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-form v-model="valid" ref="form">
                  <template v-if="typeof errors === 'object' && Object.keys(errors).length >0">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">                        
                      <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                      >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else-if="errors.length >0 ? true: false">
                    <v-row>
                      <v-col cols="12" sm="12" md="12"> 

                          <v-alert
                            dense
                            outlined
                            
                            type="error"
                          >{{ errors }}</v-alert>

                      </v-col>
                    </v-row>
                  </template >
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    :label="'Password' | translate"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                   
                  </v-text-field>
                  <v-text-field
                    v-model="confirmpassword"
                    :label="'Confirm Password'  | translate"
                    :rules= "confirmpasswordRules"
                    name="confirmpassword"
                    prepend-icon="lock"
                    type="password"
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                   
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="updatePassword">{{ 'Update' | translate }}</v-btn>
              </v-card-actions>
            </v-container>
          </v-card>

          <v-card class="elevation-12" v-else-if='token == null && loadingdata == false && routerenter == false'>
            <v-toolbar color="primary" dark flat>
              <v-container>
                <v-toolbar-title>{{ 'Update Password' | translate }}</v-toolbar-title>
              </v-container>
              <v-spacer />
              <v-toolbar-items>
                <v-select
                  @change="changedLanguage"
                  :value="selectedLanguage"
                  :items="languages"
                  item-value="lang_code"
                  item-text="lang_name"
                  :label="'Language' | translate "
                  outlined
                  dense
                  class="pt-3"
                  style="width:140px;"
                ></v-select>
              </v-toolbar-items>
            </v-toolbar>
            <v-container>
              <v-card-text>
                <v-alert dense outlined  type="error">{{ message }}</v-alert>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="goToLogin()">{{ 'Go to Login' | translate }}</v-btn>
              </v-card-actions>

            </v-container>
          </v-card>

        </v-col>
      </v-row>
      <v-overlay :value="isLoading">
          <v-layout row justify-center v-if="isLoading">
            <v-dialog v-model="isLoading" persistent fullscreen content-class="loading-dialog">
              <v-container fill-height>
                <v-layout row justify-center align-center>
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-layout>
              </v-container>
            </v-dialog>
          </v-layout>
        </v-overlay>



    </v-container> 
  </v-content>
</template>

<script>
import Vue from "vue";
import { LOGOUT, RESET_STATE, PAGES_RESET_STATE, STRIPE_RESET_STATE, CHECK_TOKEN, CHECK_AUTH, FETCH_LANGUAGES, FETCH_PAGES, UPDATE_PASSWORD } from "@/store/actions.type"
import { PURGE_AUTH,SET_LOADING, SET_LOGGED_IN, SET_CUR_LANGUAGE, SET_ROUTER_ENTER} from "@/store/mutations.type"
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "ResetPassword",
  async beforeRouteEnter(to, from, next) {
    Promise.all([
    await store.commit(SET_LOGGED_IN, false),
    await store.dispatch(STRIPE_RESET_STATE),
    await store.dispatch(PAGES_RESET_STATE),
    await store.commit(PURGE_AUTH),
    await store.dispatch(RESET_STATE),
    await store.dispatch(LOGOUT),
    await store.commit(SET_LOADING, true),
    await store.commit(SET_ROUTER_ENTER, true)
    ])


    return next();
  },
  created() {
    this.changedLanguage(this.selectedLanguage)
    this.$store.commit(SET_LOADING, true)
    if(this.$route.query.token && this.$route.query.is_comp_admin){
       store.dispatch(CHECK_TOKEN, this.$route.query.token+'?is_comp_admin='+this.$route.query.is_comp_admin+'&email='+encodeURIComponent(this.$route.query.email)+"&is_joining="+this.$route.query.is_joining).then(resp =>{
          if(resp.data !=undefined && resp.data.success == false && resp.data.message == "redirect"){
            this.$router.push('/login')
            return;
          }         
         if(resp !=undefined && resp.success){
          this.email = this.$route.query.email
          this.token = this.$route.query.token
          this.$store.commit(SET_LOADING, false)
          this.$store.commit(SET_ROUTER_ENTER, false)

         }
         else{
           this.token = null
           this.message = resp.data.message
           this.$store.commit(SET_LOADING, false)
           this.$store.commit(SET_ROUTER_ENTER, false)
         }
       })

    }
    else if(this.$route.query.token){
       store.dispatch(CHECK_TOKEN, this.$route.query.token+'?email='+encodeURIComponent(this.$route.query.email)+"&is_joining="+this.$route.query.is_joining).then(resp =>{
        if(resp.data !=undefined && resp.data.success == false && resp.data.message == "redirect"){
          this.$router.push('/login')
          return;
        }
         if(resp !=undefined && resp.success){
          this.email = this.$route.query.email
          this.is_comp_admin = this.$route.query.is_comp_admin
          this.token = this.$route.query.token
          this.$store.commit(SET_LOADING, false)
          this.$store.commit(SET_ROUTER_ENTER, false)

         }
         else{
           this.token = null
           this.message = resp.data.message
           this.$store.commit(SET_LOADING, false)
           this.$store.commit(SET_ROUTER_ENTER, false)
         }
       })

    }
    this.$store.commit(SET_ROUTER_ENTER, false)

  },   
  data() {
    return {
      valid: false,
      isLoading:false,
      password: "",
      confirmpassword: "",   
      email: null,
      is_comp_admin: null,
      token: null,
      message: null,
      };
  },
  methods: {
    goToLogin(){
      this.$router.push("/login")
    },      
    updatePassword: function() {
      if (this.$refs.form.validate()) {
        this.$store.commit(SET_LOADING, true)
        this.isLoading = true
        let password = this.password
        let email = this.userTokenData.email
        let token = this.userTokenData.token
        let is_joining = this.$route.query.is_joining
        let is_comp_admin =  (this.$route.query.is_comp_admin? 1 : '' )
        var data = {}
        if(is_comp_admin){
          data = {password, email, token, is_comp_admin, is_joining}
        }
        else{
          data = {password, email, token, is_joining}
        }
        this.$store
          .dispatch(UPDATE_PASSWORD, data)
          .then(async resp =>{
            if(resp != undefined && resp.success){
             await this.$store.dispatch(CHECK_AUTH).then( async userresp =>{
              if(userresp !== undefined && userresp.hasOwnProperty('success') && userresp.success ==true){
                 await this.$store.dispatch(FETCH_LANGUAGES, '').then(async resp =>{
                  if(resp.success){
                  this.$store
                    .dispatch(FETCH_PAGES, "?lang_ids=" + (this.curLanguage != null ? this.curLanguage.lang_id : userresp.data.user.company.language.lang_id)).then(resp => {
                      if (resp.success) {
                        var date = new Date();
                        let days = days || 365;
                        date.setTime(+ date + (days * 86400000));
                        document.cookie ='company_domain='+location.host+'; domain='+ process.env.VUE_APP_ENV_DOMAIN +'; expires='+date.toGMTString()+'; path=/;'
                        this.$store.commit(SET_LOADING, false)
                        this.isLoading = false
                        this.$router.push("/learningcenter")
                      }
                    });
                  }
                }) 
              }
             })
            }
            else{
              this.$store.commit(SET_LOADING, false)
            }
          } );        
      }
    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    async changedLanguage(value) {
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value === x.lang_code);
      this.selLanguage(selectedLanguage)
    },
  },
  computed: {
    ...mapGetters(["userTokenData",'loggedin', 'loadingdata','routerenter','curLanguage']),
    passwordRules(){
      return [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters long',
        v => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/.test(v) || 'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character',
        ]
    },
    confirmpasswordRules(){ 
    return [
      password => !!password || 'Confirm Password is required',
      password => password && password.length >= 8 || 'Confirm Password must be at least 8 characters long',
      password => /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/.test(password) || 'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character',
      confirmation => confirmation === this.password || 'Passwords must match'
      ]
    },
    isAuthenticated(){ return this.$store.getters.isAuthenticated},
    selectedLanguage(){
      return this.curLanguage !== null ? this.curLanguage.lang_code : 'de'
    },  
    languages(){
      let data = [{"lang_id":1,"lang_name": this.$t("English"),"lang_code":"en"},{"lang_id":2,"lang_name": this.$t("German"),"lang_code":"de"}]
      return data
    },      
  ...mapState({
    errors: state => state.auth.autherrors,
  })
  }
};
</script>
